import { TOGGLE_SIDEBAR } from "../constants/sidebar"

const initialState = {
  sidebarOpen: true
}

export function sideBarState(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarOpen: action.payload || !state.sidebarOpen
      }
    default:
      return state
  }
}
